export default {
    onShareAppMessage () {
        const sub_page = encodeURIComponent('/pages/packageA/residence_points/main')
        return this.getShareInfo({
            title: '成都积分落户查询',
            path: `/pages/index/main?sub_page=${sub_page}`
        })
    }
}